import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {authService} from './index'
import {Forbidden, Loader, Login, Router} from './Components'

export const App = observer(() => {
    const {currentUser, isTokenValid} = authService
    if (!currentUser || !isTokenValid) return <Login/>
    if (authService.dataLoader.isPending) {
        return <Loader show={true}/>
    } else if (!authService.isSSMMember && !authService.hasScannerAppAccess) {
        return <Forbidden/>
    }
    return <Router/>
})
